import { customerConstants } from "../constants";

const initialState = {
  customers: [],
  loading: false,
};

export function getCustomers(state = initialState, action) {
  switch (action.type) {
    case customerConstants.GET_CUSTOMERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case customerConstants.GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.data?.customers || action.customers || [],
        pagination: action.data?.pagination || state.pagination,
        loading: false,
      };
    case customerConstants.GET_CUSTOMERS_FAILURE:
      return {
        loading: false,
      };
    default:
      return state;
  }
}

export function getCustomer(state = initialState, action) {
  switch (action.type) {
    case customerConstants.GET_CUSTOMER_REQUEST:
      return {
        loading: true,
        // success: false
      };
    case customerConstants.GET_CUSTOMER_SUCCESS:
      return {
        loading: false,
        customer: action.customer,
      };
    case customerConstants.GET_CUSTOMER_FAILURE:
      return {
        loading: false,
        customer: action.error,
      };
    default:
      return state;
  }
}

export function getExcelCustomers(state = initialState, action) {
  switch (action.type) {
    case customerConstants.GET_EXCEL_CUSTOMERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case customerConstants.GET_EXCEL_CUSTOMERS_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case customerConstants.GET_EXCEL_CUSTOMERS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function addCustomerformalInfo(state = initialState, action) {
  switch (action.type) {
    case customerConstants.ADD_CUSTOMER_INFO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case customerConstants.ADD_CUSTOMER_INFO_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case customerConstants.ADD_CUSTOMER_INFO_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function uploadExcelCustomer(state = { false: false }, action) {
  switch (action.type) {
    case customerConstants.UPLOAD_EXCEL_CUSTOMERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case customerConstants.UPLOAD_EXCEL_CUSTOMERS_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case customerConstants.UPLOAD_EXCEL_CUSTOMERS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function customerToSupplier(state = { false: false }, action) {
  switch (action.type) {
    case customerConstants.CREATE_SUPPLIER_BASE_ON_CUSTOMER_REQUEST:
      return {
        currentCustomer: action.params,
        loading: true,
      };
    case customerConstants.CREATE_SUPPLIER_BASE_ON_CUSTOMER_SUCCESS:
      return {
        data: action.data,
        loading: false,
      };
    case customerConstants.CREATE_SUPPLIER_BASE_ON_CUSTOMER_FAILURE:
      return {
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function addCustomer(state = {}, action) {
  switch (action.type) {
    case customerConstants.ADD_CUSTOMER_REQUEST:
      return {
        loading: true,
      };
    case customerConstants.ADD_CUSTOMER_SUCCESS:
      return {
        data: action.data,
        loading: false,
      };
    case customerConstants.ADD_CUSTOMER_FAILURE:
      return {
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function editCustomer(state = { loading: false }, action) {
  switch (action.type) {
    case customerConstants.EDIT_CUSTOMER_REQUEST:
      return {
        loading: true,
      };
    case customerConstants.EDIT_CUSTOMER_SUCCESS:
      return {
        data: action.data,
        loading: false,
      };
    case customerConstants.EDIT_CUSTOMER_FAILURE:
      return {
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

let notesCustomerInitialState = {
  list: {
    items: [],
    loading: false,
    hasError: null,
  },
  add: {
    loading: false,
    hasError: null,
  }
}

export function notesCustomer(state = notesCustomerInitialState, action) {
  switch (action.type) {
    case customerConstants.ADD_CUSTOMER_NOTE_REQUEST:
      return {
        ...state,
        add: {
          ...state.add,
          loading: true,
        }
      };
    case customerConstants.ADD_CUSTOMER_NOTE_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
        }
      };
    case customerConstants.ADD_CUSTOMER_NOTE_FAILURE:
      return {
        ...state,
        add: {
          loading: false,
          hasError: action.error,
        }
      };
    case customerConstants.GET_CUSTOMER_NOTES_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
        }
      };
    case customerConstants.GET_CUSTOMER_NOTES_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          items: action.data,
        }
      };
    case customerConstants.GET_CUSTOMER_NOTES_FAILURE:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          hasError: action.error,
        }
      };
    default:
      return state;
  }
}


export function customerRelationToUser(state = { loading: false, section: "", customerId: "" }, action) {
  switch (action.type) {
    case customerConstants.GET_CUSTOMER_RELATION_TO_USER_REQUEST:
      return {
        ...state,
        loading: true,
        section: action.data.section,
        customerId: action.data.customerId
      };
    case customerConstants.GET_CUSTOMER_RELATION_TO_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
      };
    case customerConstants.GET_CUSTOMER_RELATION_TO_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
